import { render, staticRenderFns } from "./Trends.vue?vue&type=template&id=5d1803dd&scoped=true&lang=pug"
import script from "./Trends.vue?vue&type=script&lang=js"
export * from "./Trends.vue?vue&type=script&lang=js"
import style0 from "./Trends.vue?vue&type=style&index=0&id=5d1803dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1803dd",
  null
  
)

export default component.exports